import { render, staticRenderFns } from "./AppLoadView.vue?vue&type=template&id=b6328618&scoped=true&"
import script from "./AppLoadView.vue?vue&type=script&lang=ts&"
export * from "./AppLoadView.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoadView.vue?vue&type=style&index=0&id=b6328618&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6328618",
  null
  
)

export default component.exports